export default {
    'CreateTime': 'Create Time：',
    'OK': 'OK',
    'NoItems': 'There is no options,please connect with IT',
    'Processing': 'Processing',
    'Completed': 'Completed',
    'Cancled': 'Canceled',
    'Draft': 'Drash',
    'Filter': 'Filter',
    'NoFilterTip': 'There is no filter options',
    'SequenceStatus': 'Sheet Status',
    'NoPermissionAdd': 'You have not the permission to initiate the process',
};
